import type { SourcingEventV2Dto } from "../../../../../../autogen/bff-api";
import type { TemplateSection } from "../../../../../../common/library/templateFromEvent";
import { useRunsPublicProcurements } from "../../../../../../common/organization/useRunsPublicProcurements";
import { useSub } from "../../../../../../common/subscription/useSub";
import {
  resolveInclusions,
  resolveProcess,
  type OrgWizardAccess,
  type PublicEventStep,
} from "../../wizardSteps";

const STEP_OF_SECTION: Record<TemplateSection, PublicEventStep> = {
  minimum: "minimumRequirements",
  selection: "qualification",
  award: "awardCriteria",
};

export type SectionStepNumbers = Partial<Record<TemplateSection, number>>;

export const useSectionStepNumbers = (
  event: SourcingEventV2Dto,
  definedSections: TemplateSection[]
): SectionStepNumbers => {
  const sub = useSub();
  const runsPublicProcurements = useRunsPublicProcurements();
  const access: OrgWizardAccess = {
    hasPublicProcurementAccess: runsPublicProcurements,
    hasProductAccess: sub.hasProductAccess,
  };
  const procedureType = event.eventContext.type === "Public" ? event.eventContext.procedureType : null;
  const current = resolveInclusions(event.eventData);
  const process = resolveProcess(event.eventContext.type, access, {
    procedureType: procedureType ?? undefined,
    inclusions: {
      ...current,
      minimumRequirements: current.minimumRequirements || definedSections.includes("minimum"),
      awardCriteria: current.awardCriteria || definedSections.includes("award"),
    },
  });

  const numbers: SectionStepNumbers = {};
  for (const [section, key] of Object.entries(STEP_OF_SECTION) as [TemplateSection, PublicEventStep][]) {
    const index = (process?.steps ?? []).findIndex((s) => s.key === key);
    if (index >= 0) numbers[section] = index + 1;
  }
  return numbers;
};
